import { Fragment, type ReactNode } from 'react';
import { AUTHORS, splitAuthors } from '../lib/authors';

interface Props {
  /** Le texte déjà localisé. */
  readonly children: string;
  /** Habillage des liens, fourni par le skin. */
  readonly linkClassName?: string | undefined;
}

/**
 * Un texte dont les noms d'auteurs deviennent des liens.
 *
 * Sert dans les paragraphes de présentation qui citent Vigz et Tomo : le pied
 * de page les crédite déjà, mais un nom cité au fil du texte doit lui aussi
 * mener quelque part.
 *
 * `rel="noopener"` coupe l'accès à `window.opener` ; `noreferrer` fait doublon
 * avec l'en-tête `Referrer-Policy` du site, mais tient si la page est un jour
 * servie ailleurs.
 */
export function AuthorText({ children, linkClassName }: Props): ReactNode {
  return (
    <>
      {splitAuthors(children).map((part, index) =>
        part.kind === 'author' ? (
          <a
            key={index}
            className={linkClassName}
            href={AUTHORS[part.name]}
            target="_blank"
            rel="noopener noreferrer"
          >
            {part.name}
          </a>
        ) : (
          <Fragment key={index}>{part.text}</Fragment>
        ),
      )}
    </>
  );
}
